import { render, staticRenderFns } from "./HamburgerIcon.vue?vue&type=template&id=edf4b0c2&scoped=true&"
import script from "./HamburgerIcon.vue?vue&type=script&lang=js&"
export * from "./HamburgerIcon.vue?vue&type=script&lang=js&"
import style0 from "./HamburgerIcon.vue?vue&type=style&index=0&id=edf4b0c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf4b0c2",
  null
  
)

export default component.exports